<template>
    <div>
        <table class="lstTable">
            <tr>
                <th v-for="header in headers" :width="header.width">
                    <div :style="header.headerStyle">
                        {{$t(header.text)}}
                    </div>
                </th>
            </tr>
            <tr v-for="(item,index) in items">
                <td class="text-xs-center">{{ index+1}}
                </td>
                <td class="text-xs-left">
                    {{item.documentCode}}
                </td>
                <td align="left">
                    {{item.documentName}}
                </td>
                <td align="right">
                    <i-upload label=""
                              v-model="item.documentId"
                              file-type="attach" :multifile="false"
                              accept=".docx"
                              :key="'document_'+index+item.procDocId"
                              :name="'document_'+index+item.procDocId"
                              :data-vv-as="$t('lang.procedure.document')"
                              :error-messages="errors.first('document')"
                    />
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    import axios from "axios";
    import {message} from "@/shared/message";
    import IUpload from "../../components/form/Upload";

    export default {
        name: "file-document",
        components: {IUpload},
        props: {
            rowsPerPageItems: {
                type: [Array, Number],
                default: () => [10, 20, 30, 40, 50]
            },
        },

        data: () => ({
            showList: true,
            sortField: "",
            orderBy: "asc",
            headers: [
                {
                    text: "lang.common.no",
                    align: "left",
                    sortable: false,
                    search: false,
                    value: "name",
                    width: "10%"
                },
                {
                    text: "lang.procedure.documentCode",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "documentCode",
                    width: "15%"
                },
                {
                    text: "lang.procedure.documentName",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "documentName",
                    width: "35%"
                },
                {
                    text: "lang.files.document",
                    align: "right",
                    sortable: false,
                    search: false,
                    value: "documentId",
                    width: "40%"
                }
            ],
            lstTask: [],
            items: [],
            search: "",
            err: {
                fullName: [],
                phone: [],
                email: []
            },
            editingItem: null,
            editorData: "",
            pagination: {
                rowsPerPage: 10,
                page: 1,
                totalItems: 0,
            },
            fileId: null,
            task: null,
        }),

        watch: {
        },

        created() {
        },

        methods: {
            getDocuments(fileId, task) {
                this.fileId = fileId;
                this.task = task;
                axios.post(process.env.VUE_APP_API_URL + "/files/document/list?fileId=" + this.fileId + "&task=" + encodeURI(this.task)).then(
                    data => {
                        this.items = data;
                    }
                )
            },

            onSave() {
                for (let i = 0; i < this.items.length; i++) {
                    if (this.items[i].numberOfObject == null || this.items[i].numberOfObject < 0) {
                        message.error("number Of Object is not allow null");
                        return;
                    }
                    this.items[i].total = this.items[i].numberOfObject * this.items[i].fee;

                }
                axios.post(process.env.VUE_APP_API_URL + "/files/document/save?fileId=" + this.fileId + "&task=" + encodeURI(this.task), this.items).then(
                    data => {
                        if (data.success) {
                            message.success(this.$t("lang.common.update_success"));
                        } else {
                            message.error(data.description);
                        }
                    }
                )
            },

        }
    };
</script>